import { allFilms } from "./allFilms";

export const anniversaryFilms = allFilms.filter(function(obj) { return obj.type === 'Aniversário'; });